import { useCookies } from 'vue3-cookies'

const { cookies } = useCookies()

export default cookies
